/**
 * Created by sagardesai on 28/06/18.
 */

export const BROADCASTER_DETAIL_REQUEST = "BROADCASTER_DETAIL_REQUEST";
export const BROADCASTER_DETAIL_RECEIVE = "BROADCASTER_DETAIL_RECEIVE";
export const BROADCASTER_DETAIL_FAILURE = "BROADCASTER_DETAIL_FAILURE";
export const RESET_BROADCASTER_DETAIL = "RESET_BROADCASTER_DETAIL";

export const BROADCAST_DETAIL_REQUEST = "BROADCAST_DETAIL_REQUEST";
export const BROADCAST_DETAIL_RECEIVE = "BROADCAST_DETAIL_RECEIVE";
export const BROADCAST_DETAIL_FAILURE = "BROADCAST_DETAIL_FAILURE";
export const RESET_BROADCAST_DETAIL = "RESET_BROADCAST_DETAIL";

export const SIMILAR_BROADCASTER_REQUEST = "SIMILAR_BROADCASTER_REQUEST";
export const SIMILAR_BROADCASTER_RECEIVE = "SIMILAR_BROADCASTER_RECEIVE";
export const SIMILAR_BROADCASTER_FAILURE = "SIMILAR_BROADCASTER_FAILURE";
export const RESET_SIMILAR_BROADCASTER = "RESET_SIMILAR_BROADCASTER";

export const TRENDING_BROADCASTERS_LIST_REQUEST = "TRENDING_BROADCASTERS_LIST_REQUEST";
export const TRENDING_BROADCASTERS_LIST_RECEIVE = "TRENDING_BROADCASTERS_LIST_RECEIVE";
export const TRENDING_BROADCASTERS_LIST_FAILURE = "TRENDING_BROADCASTERS_LIST_FAILURE";
export const RESET_TRENDING_BROADCASTERS_LIST = "RESET_TRENDING_BROADCASTERS_LIST";

export const BROADCASTS_LIST_SORT_BY = "BROADCASTS_LIST_SORT_BY";
export const RESET_BROADCASTS_LIST_SORT_BY = "RESET_BROADCASTS_LIST_SORT_BY";

export const SET_SEARCH_FOR_BROADCASTER_STATE = "SET_SEARCH_FOR_BROADCASTER_STATE";